export const ShowMoveDetails = ({ showMoveDetails, action }) => (
    <button
        className="btn btn-link w-100 text-secondary mb-0"
        onClick={action}
    >
       {showMoveDetails ? "Show Less Details" : "Show Move Details"}
    </button>
);